// v18.5 — Sample URL normalizer.
// Historical bug: curated_projects saved to MongoDB stored `sampleUrl`
// as an absolute URL prefixed with the DEV/PREVIEW origin
// (https://beat-maker-266.preview.emergentagent.com). When a producer
// generates or hydrates a beat on a different host (production
// crowdaw.com, a fork preview, a guest Chrome window against prod),
// the browser tries to fetch cross-origin from a host that doesn't
// send permissive CORS headers → fetch fails → GenPlayer falls back
// to the generic default kit instead of the source 808/Hi-Hat/etc.
//
// This module rewrites ANY /api/static (or /api/*) URL so its origin
// matches the current REACT_APP_BACKEND_URL. Relative paths pass
// through untouched. Non-API URLs (e.g., blob:, data:, external CDN)
// are also untouched.
//
// Contract: input `null | undefined | string` → same shape out.
const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

export function normalizeSampleUrl(url) {
  if (!url || typeof url !== "string") return url;
  // Pass through blob:, data:, filesystem: and any other non-http scheme.
  if (!/^https?:\/\//i.test(url)) {
    // Rewrite root-relative /api/... paths against the configured backend
    // if we have one; otherwise leave as-is (browser will resolve against
    // current origin, which typically works via Kubernetes /api ingress).
    if (url.startsWith("/api/") && BACKEND) return `${BACKEND}${url}`;
    return url;
  }
  try {
    const u = new URL(url);
    // Only rewrite paths under /api/ — external CDNs must be left alone.
    if (!u.pathname.startsWith("/api/")) return url;
    // If it already matches the current backend, no-op.
    if (BACKEND && url.startsWith(BACKEND + "/")) return url;
    if (BACKEND) return `${BACKEND}${u.pathname}${u.search}${u.hash}`;
    // No backend configured (shouldn't happen at runtime) — return the
    // pathname only so the browser resolves it against the current origin.
    return `${u.pathname}${u.search}${u.hash}`;
  } catch {
    return url;
  }
}

export default normalizeSampleUrl;
